import BasicDetails from "../../components/Register/BasicDetails";
import BusinessProof from "../../components/Register/BusinessProof";
import ProfileCreation from "../../components/Register/ProfileCreation";
import RegistrationSideBar from "../../components/Register/RegistrationSideBar";
import ShopLocation from "../../components/Register/ShopLocation";
import Arrow from "../../assets/Register/arrowleft.svg";
import { Image } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../../Routes";
import Notification from "../../modals/Notification";
import { userSignup } from "../../components/Actions/userActions";
import CompleteProfile from "../../modals/CompleteProfile";
import { useNavigate } from "react-router";
import AlreadyRegisteredModal from "../../modals/AlreadyRegisteredmodal";
import { useTranslation } from "react-i18next";
import "../../styles.css";
import {
  LoginData,
  loginUser,
  loginUserSuccess,
} from "../../Redux/Action/loginAction";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import LoadingSpinner from "../../components/Loading";
import { toast } from "react-toastify";
import ShopRegistration from "../../components/Register/ShopRegistration";

const UserRegistration = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [data, setretailerInfo] = useState("");
  const [mobile, setuserPhone] = useState("");
  const [existemail, setexistemail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentpage, setcurrentpage] = useState(0);
  const { user } = useSelector((state) => state?.login);
  const [component, setComponent] = useState(() => 0);
  const [shopLocationData, setshopLocationData] = useState("");
  //Use States
  // const [BasicDetailData, setsBasicDetailData] = useState("");
  const [BusinessProofData, setBusinessProofData] = useState("");
  const [showNotification, setshowNotification] = useState(false);
  const [showNotificationMessage, setshowNotificationMessage] = useState("");
  const [showCompleteModal, setShowCompleteModal] = useState(false); // State for modal visibility
  const dispatch = useDispatch();

  useEffect(() => {
    const retailerInfo = localStorage.getItem("retailer_info");
    const userPhone = localStorage.getItem("UserPhone");
    setretailerInfo(retailerInfo ? JSON.parse(retailerInfo) : "");
    setuserPhone(userPhone || "");
  }, [user]);

  const handleDataSubmit = (Data) => {
    setLoading(true);
    const response = dispatch(userSignup(Data));
    response
      .then((result) => {

        if (result?.payload?.result?.status_code === 200) {
          setshopLocationData(Data);
          let payload = {
            user_name: Data?.email,
          };
          dispatch(LoginData(payload))
            .then((data) => {
              if (data?.result?.status_code === 200) {
                dispatch(loginUserSuccess(data));
                setShowCompleteModal(true);
              } else {
                setshowNotificationMessage(t(data?.result?.status));
              }
            })
            .catch((loginError) => {
              console.error("Error during login:", loginError);
            });
        } else if (
          result?.payload?.result?.status ==
            "With Email Retailer Already Registered" ||
          result?.payload?.error?.data?.message ==
            "You can not have two users with the same login!"
        ) {
          toast.error(t("Retailer is already registered with this Email"));
        } else if (result?.payload?.result?.status_code === 400) {
          toast.error(t(result?.payload?.result?.status));
        }

        console.log("usercreation", JSON.stringify(Data));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
        console.log("Signup process finished");
      });
  };

  return (
    <div className="flex bg-white min-h-screen scrollbar-none relative w-full">
      {loading && <LoadingSpinner />}

      <div className="w-full max-w-7xl mx-auto">
        {/* Modal Messages */}
        {showNotification && (
          <AlreadyRegisteredModal message={showNotificationMessage} />
        )}
        {showCompleteModal && (
          <CompleteProfile onClose={() => setShowCompleteModal(false)} />
        )}
        <ShopRegistration
          mobile={mobile}
          data={data}
          onDataSubmit={handleDataSubmit}
        />
      </div>
    </div>
  );
};

export default UserRegistration;
